import { render, staticRenderFns } from "./CRTextField.vue?vue&type=template&id=2f54a5f6&scoped=true"
import script from "./CRTextField.vue?vue&type=script&lang=js"
export * from "./CRTextField.vue?vue&type=script&lang=js"
import style0 from "./CRTextField.vue?vue&type=style&index=0&id=2f54a5f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f54a5f6",
  null
  
)

export default component.exports